import React, { useState, useEffect } from "react";
import global from "../../global-variables";
import Header from "../layout/header";
import { Link } from "react-router-dom";
import $ from "jquery";
import WOW from "wowjs";
import { FaLink, FaImage, FaRegFilePdf, FaVideo, FaChevronRight } from "react-icons/fa";

import { Container, Row, Col } from "reactstrap";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Metatag from "../../hooks/Metatag";


export default function CampusSustainability() {
  const [show, setShow] = useState(false);
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  useEffect(() => {
    $(window).on("scroll", function () {
      $(".navbar").offset().top > 10 ? $(".fixed-top").removeClass("bg-header-home") : $(".fixed-top").removeClass("bg-header-home")
    });

    // initiate the wow effect
    new WOW.WOW({
      live: false,
    }).init();


  }, []);


  return (
    <>
      <Header></Header>

      <Metatag title='IIT Bombay Campus Sustainability Assessment'
        description='IIT Bombay Campus Sustainability Assessment and Implementation Plan'
        keywords='IIT Bombay Campus Sustainability Assessment, IIT Bombay Campus Sustainability Plan, IIT Bombay Sustainability Tracking Assessment & Rating System - STARS'
      />

      {/* Visual Panel */}
      <Container fluid className="bg-visual-inside px-0" >
        <div className="visual-inside-big visual-container-inside">
          <Container >
            <Row className="g-md-0 rounded-4">
              <Col md={12}>
                <div className="py-md-4">
                  <div className="m-0 text-center py-xl-3 p-2 text-white">
                    <h1 className="fw-light text-white m-0 align-self-center wow fadeInUp">
                      Policy
                    </h1>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>

      {/* Container */}
      <Container className="my-5 pt-4 pt-xl-5">
        <Row className="g-0">

          <div className="border rounded-4 p-xl-5 p-3 h-100">
            <Col md={12} lg={11}>
              <Row>
                <Col md={5} lg={3}>
                  <Link to="../images/pdf/sustainability-policy-IITB.pdf" target="_blank" className="nav-link">
                    <img src={global.variables.strDomainUrl + "images/pic-campus-sustainability.png"} className="img-fluid border rounded-4 mb-md-0 mb-4" alt="" title="" />
                  </Link>
                </Col>
                <Col md={7} lg={9} className="list ps-lg-5 d-flex align-items-center">
                  <div>
                    <p>IIT Bombay is renowned for excellence in education and research. Its 489-acre residential campus supports nearly 25,000 people and diverse biodiversity, with half the area covered in greenery. As infrastructure expands to meet growing demands, sustainability remains a key priority.</p>
                    <p>GESH IITB is committed to addressing India’s sustainability challenges by promoting technological innovations, policy interventions, and resource-efficient management. GESH IITB is implementing a systematic framework to assess campus sustainability through data collection aligned with national and global rating systems, ensuring that IIT Bombay leads India’s sustainability transition.</p>
                    <p>A strong academic foundation complements these efforts. IIT Bombay integrates sustainability across disciplines through a wide range of undergraduate, postgraduate, and interdisciplinary courses. These courses equip students with the knowledge and skills to understand environmental challenges, explore green technologies, and identify opportunities for sustainable development. In doing so, IIT Bombay plays a pivotal role in preparing the next generation of leaders, innovators, and policymakers to drive India’s sustainable future. A complete list of sustainability-related courses is available through the academic inventory. (<Link to="https://docs.google.com/spreadsheets/d/10sHXBwt6Q2bL3BJLKcvFiW86nnLVB969vqd0VIixCO0/edit?usp=sharing" target="_blank">Click here for IITB Sustainability Courses</Link>)</p>
                    <p className="m-0">Additionally with the pioneering GESH IITB Living Lab Program, we envision placing IIT Bombay as a model campus for sustainability and innovation.</p>
                  </div>
                </Col>
              </Row>
            </Col>
          </div>
        </Row>
      </Container>

      {/* Breadcrumb */}
      <Breadcrumb className="breadcrumb-panel mt-auto">
        <Breadcrumb.Item href={global.variables.strDomainUrl}>Home</Breadcrumb.Item>
        <Breadcrumb.Item active>Campus Sustainability</Breadcrumb.Item>
        <Breadcrumb.Item active>Sustainability @ IITB</Breadcrumb.Item>
        <Breadcrumb.Item active>Policy</Breadcrumb.Item>
      </Breadcrumb>
    </>
  );
}